import React from "react";
import { cn } from "../../lib/utils";

/** Soocher "S" mark used in the sidebar, login and loading screens. */
const BrandMark = ({ className, size = 36 }) => (
  <div
    className={cn(
      "flex shrink-0 items-center justify-center rounded-xl bg-primary font-bold text-primary-foreground shadow-sm",
      className
    )}
    style={{ width: size, height: size, fontSize: Math.round(size * 0.5) }}
    aria-hidden="true"
  >
    S
  </div>
);

export default BrandMark;
